import njordUtbetalingsoversiktReducer, { defaultState } from "./njordUtbetalingsoversiktReducer";

export { defaultState };
export default njordUtbetalingsoversiktReducer;
